import { render, staticRenderFns } from "./CampaignDialog.vue?vue&type=template&id=a80a4dd4&scoped=true&"
import script from "./CampaignDialog.vue?vue&type=script&lang=js&"
export * from "./CampaignDialog.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDialog.vue?vue&type=style&index=0&id=a80a4dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80a4dd4",
  null
  
)

export default component.exports